let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9OfUc")).then(() => parcelRequire('8QYui'));